import { animate, state, style, transition, trigger } from '@angular/animations';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, ElementRef, Inject, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatInput } from '@angular/material/input';
import { Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { SoundType } from '../../../../classes/sound-type';
import { DetachedRouteHandlesService } from '../../../../configuration/route-caching-strategy/detached-route-handles.service';
import { API_BASE_URL_SERVICE } from '../../../../kiene-core.config';
import { AppService } from '../../../../services/app/app.service';
import { KieneBackendApiService } from '../../../../services/backend-api/kiene-backend-api.service';
import { MessageService } from '../../../../services/message-service/message.service';
import { ConfirmDialogInput, ConfirmDialogResult } from '../../../dialogs/confirm-dialog/confirm-dialog';
import { ConfirmDialogComponent } from '../../../dialogs/confirm-dialog/confirm-dialog.component';
import { GruppeTier } from '../../../gruppe-tier/classes/gruppe-tier';
import { GruppeTierReklamierenDialogComponent } from '../../../gruppe-tier/gruppe-tier-reklamieren-dialog/gruppe-tier-reklamieren-dialog.component';
import { Haendler } from '../../../stammdaten/haendler/haendler';
import { HaendlerDetailsDialogComponent } from '../../../stammdaten/haendler/haendler-details-dialog/haendler-details-dialog.component';
import { StammdatenService } from '../../../stammdaten/stammdaten.service';
import { BetriebskontakteService } from '../../../stammdaten/betriebskontakte/betriebskontakte.service';
import { Betriebskontakt } from '../../../stammdaten/betriebskontakte/betriebskontakt';
import { Gruppe } from '../../classes/gruppe';
import { GewichtEingebenNumberpadDialogComponent } from './gewicht-eingeben-numberpad-dialog/gewicht-eingeben-numberpad-dialog.component';
import { TransponderNummerEingebenDialogComponent } from '../transponder-nummer-eingeben-dialog/transponder-nummer-eingeben-dialog.component';
import { EinstallHerkunftFilter, ScanErgebnis } from '../../classes/scan-ergebnis';
import { GruppenService } from '../../gruppen.service';
import { EinstallenService } from '../einstallen.service';
import { LocalStorageService } from '../../../../services/local-storage/local-storage.service';
import { canEditHaendler as userCanEditHaendler } from '../../../stammdaten/haendler/haendler-permissions';
import { GruppeTierScanImportierenDialogComponent } from '../../../gruppe-tier/gruppe-tier-pass-scan-verwaltung/gruppe-tier-scan-importieren-dialog/gruppe-tier-scan-importieren-dialog.component';
import { GruppeTierScanImportierenDialogPrefill } from '../../../gruppe-tier/gruppe-tier-pass-scan-verwaltung/gruppe-tier-scan-importieren-dialog/gruppe-tier-scan-importieren-dialog.data';
import { GruppeTierPassScanVerwaltungComponent } from '../../../gruppe-tier/gruppe-tier-pass-scan-verwaltung/gruppe-tier-pass-scan-verwaltung.component';
import {
    hasOhrmarkeScanned,
    hasPassScanned,
    isComplementScanSuccess,
    isDuplicateScanType,
    getInvalidOhrmarkePassScanLengthMessage,
    isInvalidOhrmarkePassScanLength,
    isValidOhrmarkePassScanLength,
    normalizeOhrmarkePassScanInput,
    OHRMARKE_SCAN_LENGTH,
    PASS_SCAN_LENGTH,
} from '../../../../utils/ohrmarke-pass-scan.util';
import { KieneUtils } from '../../../../utils/KieneUtils';

@Component({
    selector: 'kiene-einstallen-tiere-hinzufuegen',
    templateUrl: './einstallen-tiere-hinzufuegen.component.html',
    styleUrls: ['./einstallen-tiere-hinzufuegen.component.scss'],
    animations: [
        trigger('openClose', [
            state('open', style({ backgroundColor: 'rgba(55, 126, 34, 0.8)' })),
            state('closed', style({ backgroundColor: 'rgba(55, 126, 34, 0)' })),
            transition('open => closed', [animate('1s')]),
            transition('closed => open', [animate('0.5s')]),

            state('openDuplicate', style({ backgroundColor: 'rgba(255, 150, 45, 0.8)' })),
            state('closeDuplicate', style({ backgroundColor: 'rgba(255, 150, 45, 0)' })),
            transition('openDuplicate => closeDuplicate', [animate('1s')]),
            transition('closeDuplicate => openDuplicate', [animate('0.5s')]),

            state('openError', style({ backgroundColor: 'rgba(155, 0, 36, 0.8)' })),
            state('closedError', style({ backgroundColor: 'rgba(155, 0, 36, 0)' })),
            transition('openError => closedError', [animate('1s')]),
            transition('closedError => openError', [animate('0.5s')]),
        ]),
    ],
})
export class EinstallenTiereHinzufuegenComponent implements OnInit, OnDestroy {
    readonly hasPassScanned = hasPassScanned;
    readonly hasOhrmarkeScanned = hasOhrmarkeScanned;
    private readonly gewichtPermissionId = 9161;
    passSourceMode: 'none' | 'haendler' | 'kontakt' = 'none';
    haendlerFavoritenSubscription: Subscription;
    gruppeTierSubscription: Subscription;
    gruppeSubscription: Subscription;
    einstallTierlisteSubscription: Subscription;
    private ensureEinstallTierlisteSubscription: Subscription;
    tierlisteTiereSubscription: Subscription;
    private herkunftTiereCountSubscription: Subscription;
    lastScanErgebnisseSubscription: Subscription;
    gruppeId: string;
    currentScanErgebnis: ScanErgebnis;
    datumCtrl = new UntypedFormControl();
    ohrenmarkeCtrl = new UntypedFormControl();
    bemerkungCtrl = new UntypedFormControl();
    gescannteOhrmarken: ScanErgebnis[] = [];
    readonly maxLengthOhrmarke = 15;
    readonly ohrmarkeScanLength = OHRMARKE_SCAN_LENGTH;
    readonly passScanLength = PASS_SCAN_LENGTH;
    openCloseState = 'closed';
    timeMs = null;
    haendlerFavoriten: Haendler[] = [];
    haendlerFavoritenLoading = false;
    haendlerCtrl: UntypedFormControl = new UntypedFormControl('');
    abteilCtrl: UntypedFormControl = new UntypedFormControl(null);
    mitTransponderNummerToggleCtrl = new UntypedFormControl();
    isLoading = true;

    // Neue Properties für den Betriebskontakt-Auswahl-Dialog
    selectedBetriebskontakte: any[] = [];
    betriebskontaktConfig = {
        showLandwirte: true,
        showHaendler: true,
        showSchlachthoefe: true,
        showAll: true,
        multiSelect: false,
        compact: true, // Kompaktere Darstellung
        title: '', // Keine Überschrift
        placeholder: 'Kontakt auswählen...',
        allowCreateNew: true,
    };
    canEditHaendler = false;
    canEditGewicht = false;
    passInputMode: 'scan' | 'excel' | 'pdf' = 'scan';
    selectedPassExcelFile: File = null;
    excelUploadInProgress = false;
    readonly scansPerPage = 20;
    scansPageIndex = 0;
    herkunftTiereCount: number | null = null;
    einstalldatumHintHighlighted = false;
    excelFormatHintVisible = false;
    private einstalldatumHintHighlightTimeout: ReturnType<typeof setTimeout> | null = null;

    @Input() gruppe: Gruppe;
    @Input() showPassReiter = false;
    @Input() forceNewEinstallTierliste = false;
    /** Parent mobile layout renders back arrow + title above tabs. */
    @Input() hideMobileHeader = false;
    einstallTierlisteInitializing = false;
    currentEinstallTierlisteId: number | null = null;

    get showPassFeatures(): boolean {
        return this.showPassReiter === true;
    }

    get isEinstalldatumMissingForScan(): boolean {
        return !this.datumCtrl.value;
    }

    get einstalldatumRequiredHintText(): string {
        if (this.passInputMode === 'excel') {
            return 'Bitte zuerst ein Einstalldatum wählen, bevor Sie eine Excel-Liste importieren.';
        }
        if (this.passInputMode === 'pdf') {
            return 'Bitte zuerst ein Einstalldatum wählen, bevor Sie ein PDF importieren.';
        }
        return 'Bitte zuerst ein Einstalldatum wählen, bevor Sie Tiere scannen.';
    }

    get isScanInputDisabled(): boolean {
        return (
            this.isLoading ||
            this.einstallTierlisteInitializing ||
            !this.einstallService.getCurrentEinstallTierlisteId() ||
            this.isEinstalldatumMissingForScan
        );
    }

    onDisabledScanFieldClick(): void {
        if (!this.isScanInputDisabled) {
            return;
        }
        if (this.isEinstalldatumMissingForScan) {
            this.showEinstalldatumRequiredHint();
            return;
        }
        if (this.einstallTierlisteInitializing || !this.einstallService.getCurrentEinstallTierlisteId()) {
            this.messageService.errorMessage('Einstall-Tierliste wird vorbereitet. Bitte kurz warten.', null);
        }
    }

    onDisabledUploadClick(): void {
        if (!this.isEinstalldatumMissingForScan) {
            return;
        }
        this.showEinstalldatumRequiredHint();
    }

    private showEinstalldatumRequiredHint(): void {
        this.clearEinstalldatumHintHighlight();
        this.einstalldatumHintHighlighted = true;
        this.einstalldatumHintHighlightTimeout = setTimeout(() => {
            this.einstalldatumHintHighlighted = false;
            this.einstalldatumHintHighlightTimeout = null;
        }, 4000);
    }

    private clearEinstalldatumHintHighlight(): void {
        if (this.einstalldatumHintHighlightTimeout) {
            clearTimeout(this.einstalldatumHintHighlightTimeout);
            this.einstalldatumHintHighlightTimeout = null;
        }
        this.einstalldatumHintHighlighted = false;
    }

    get canSubmitScan(): boolean {
        if (this.isScanInputDisabled) {
            return false;
        }
        return this.isValidScanLength(this.getScanInputValue());
    }

    private getScanInputValue(): string {
        return normalizeOhrmarkePassScanInput(String(this.ohrenmarkeCtrl.value ?? ''));
    }

    private isValidScanLength(value: string): boolean {
        return isValidOhrmarkePassScanLength(value);
    }

    private rejectInvalidScanInput(rawValue?: string): boolean {
        const ohrmarke = normalizeOhrmarkePassScanInput(String(rawValue ?? this.ohrenmarkeCtrl.value ?? ''));
        if (!isInvalidOhrmarkePassScanLength(ohrmarke)) {
            return false;
        }

        this.messageService.errorMessage(getInvalidOhrmarkePassScanLengthMessage(ohrmarke), null);
        this.gruppenService.playScanSound(SoundType.ERROR);
        this.ohrenmarkeCtrl.setValue('');
        setTimeout(() => this.ohrenmarkeInput?.focus(), 0);
        return true;
    }

    @ViewChild('ohrenmarkeInput') ohrenmarkeInput: MatInput;
    @ViewChild('passExcelFileInput') passExcelFileInput: ElementRef<HTMLInputElement>;
    @ViewChild('passPdfVerwaltung') passPdfVerwaltung?: GruppeTierPassScanVerwaltungComponent;

    constructor(
        private readonly location: Location,
        private readonly route: ActivatedRoute,
        private readonly router: Router,
        private readonly http: HttpClient,
        private readonly api: KieneBackendApiService,
        private readonly messageService: MessageService,
        private readonly einstallService: EinstallenService,
        private readonly dialog: MatDialog,
        private readonly stammdatenService: StammdatenService,
        private readonly gruppenService: GruppenService,
        private readonly betriebskontakteService: BetriebskontakteService,
        private readonly appService: AppService,
        private readonly detachedRouteHandlesService: DetachedRouteHandlesService,
        private readonly localStorageService: LocalStorageService,
        @Inject(API_BASE_URL_SERVICE) private readonly apiBaseUrl: string,
    ) {
        this.gruppeId = this.route.snapshot.paramMap.get('gruppeid');
    }

    ngOnDestroy(): void {
        this.clearEinstalldatumHintHighlight();
        this.gruppeSubscription?.unsubscribe();
        this.einstallTierlisteSubscription?.unsubscribe();
        this.ensureEinstallTierlisteSubscription?.unsubscribe();
        this.tierlisteTiereSubscription?.unsubscribe();
        this.herkunftTiereCountSubscription?.unsubscribe();
        this.lastScanErgebnisseSubscription?.unsubscribe();
        this.gruppeTierSubscription?.unsubscribe();
        this.haendlerFavoritenSubscription?.unsubscribe();
    }

    goBack(): void {
        this.location.back();
    }

    ngOnInit(): void {
        this.canEditHaendler = userCanEditHaendler(this.localStorageService);
        this.canEditGewicht = this.currentUserCanEditGewicht();
        // Preserve and restore last scans when navigating between stepper steps.
        this.gescannteOhrmarken = this.einstallService.getLastScanErgebnisse();
        const savedEinstalldatum = this.einstallService.getCurrentEinstalldatum();
        if (savedEinstalldatum) {
            this.datumCtrl.setValue(savedEinstalldatum, { emitEvent: false });
        }
        this.betriebskontaktConfig = {
            ...this.betriebskontaktConfig,
            allowCreateNew: this.canEditHaendler,
        };

        this.detachedRouteHandlesService.watchChanges().subscribe(() => {
            setTimeout(() => {
                this.ohrenmarkeInput?.focus();
            }, 0);
        });

        this.loadGruppe();

        this.currentEinstallTierlisteId = this.einstallService.getCurrentEinstallTierlisteId();
        this.einstallTierlisteSubscription = this.einstallService.watchCurrentEinstallTierlisteId().subscribe({
            next: () => {
                this.currentEinstallTierlisteId = this.einstallService.getCurrentEinstallTierlisteId();
                this.onEinstallTierlisteOrHerkunftChanged();
            },
        });

        this.lastScanErgebnisseSubscription = this.einstallService.watchLastScanErgebnisse().subscribe({
            next: () => this.syncScansFromService(),
        });

        this.einstallService
            .watchCurrentAbteil()
            .subscribe({ next: val => this.abteilCtrl.setValue(val, { emitEvent: false }) });
        this.abteilCtrl.valueChanges.subscribe(abteil => {
            this.einstallService.setCurrentAbteil(abteil);
        });

        this.haendlerCtrl.valueChanges.subscribe(value => {
            if (this.currentScanErgebnis) {
                this.currentScanErgebnis.anzahl_viehhaendler = null;
            }

            // Wenn ein Händler ausgewählt wird, Kontakt-Auswahl zurücksetzen
            if (value && value.viehhaendler_id) {
                this.passSourceMode = 'haendler';
                this.selectedBetriebskontakte = [];
            }
            this.syncHerkunftToService();
            if (this.passSourceMode === 'haendler') {
                this.onEinstallTierlisteOrHerkunftChanged();
            }
        });

        this.einstallService.watchScanErgebnisSubject().subscribe({
            next: scanErgebnis => {
                this.currentScanErgebnis = scanErgebnis;
            },
        });

        this.datumCtrl.valueChanges.subscribe(value => {
            this.einstallService.setCurrentEinstalldatum(value || null);
            if (value) {
                this.clearEinstalldatumHintHighlight();
            }
            if (value) {
                setTimeout(() => this.ohrenmarkeInput?.focus(), 0);
            }
        });

        this.ladeHaendlerFavoriten();
    }

    ladeHaendlerFavoriten() {
        this.haendlerFavoritenSubscription?.unsubscribe();
        this.haendlerFavoritenLoading = true;
        this.haendlerFavoritenSubscription = this.stammdatenService.loadHaendlerFavoriten().subscribe({
            next: haendlerFavoriten => {
                this.haendlerFavoriten = haendlerFavoriten.records;
                this.haendlerFavoritenLoading = false;
            },
            error: () => {
                this.haendlerFavoritenLoading = false;
            },
        });
    }

    get showHaendlerFavoritenEmptyState(): boolean {
        return !this.haendlerFavoritenLoading && this.haendlerFavoriten.length === 0;
    }

    get lastScansEmptyHint(): string {
        if (this.getActiveHerkunftFilter()) {
            return 'Keine Tiere mit dieser Herkunft auf der aktuellen Einstall-Tierliste.';
        }
        return 'Ohrmarke oder Pass scannen, um die letzten Scans hier zu sehen.';
    }

    get isLastScansHerkunftFilterActive(): boolean {
        return !!this.getActiveHerkunftFilter();
    }

    get lastScansHerkunftFilterLabel(): string {
        const filter = this.getActiveHerkunftFilter();
        if (!filter) {
            return '';
        }
        if (filter.viehhaendlerId) {
            return this.haendlerCtrl.value?.name?.trim() || '';
        }
        if (filter.betriebskontaktHaendlerId) {
            const kontakt = this.selectedBetriebskontakte[0];
            return (kontakt?.bezeichnung_final || kontakt?.bezeichnung || '').trim();
        }
        return '';
    }

    get herkunftTiereDisplay(): string {
        if (!this.isLastScansHerkunftFilterActive) {
            return '';
        }
        if (this.herkunftTiereCount == null || Number.isNaN(Number(this.herkunftTiereCount))) {
            return '—';
        }
        return String(this.herkunftTiereCount);
    }

    get herkunftTiereCountLabel(): string {
        const count = this.herkunftTiereDisplay;
        if (!count) {
            return '';
        }
        const n = Number(count);
        if (!Number.isNaN(n) && n === 1) {
            return '· 1 Tier';
        }
        return `· ${count} Tiere`;
    }

    getScanAbteilLabel(scan: ScanErgebnis): string {
        const abteil = scan?.abteil?.trim();
        return abteil || '—';
    }

    getScanHerkunftLabel(scan: ScanErgebnis): string {
        if (!scan) {
            return '—';
        }
        if (scan.betriebskontakt_haendler_name?.trim()) {
            return scan.betriebskontakt_haendler_name.trim();
        }
        const kontaktLabel =
            scan.betriebskontaktHaendler?.bezeichnung_final?.trim() ||
            scan.betriebskontaktHaendler?.bezeichnung?.trim();
        if (scan.betriebskontakt_haendler_id && kontaktLabel) {
            return kontaktLabel;
        }
        if (scan.viehhaendler_name?.trim()) {
            return scan.viehhaendler_name.trim();
        }
        return '—';
    }

    getScanErrorTooltip(scan: ScanErgebnis): string {
        if (!scan) {
            return '';
        }
        const fehler = scan.fehler?.trim();
        if (fehler) {
            return fehler;
        }
        return 'Tier konnte nicht importiert werden.';
    }

    getScanStatusIcon(scan: ScanErgebnis): string {
        if (this.isScanImportFailed(scan)) {
            return 'error';
        }
        if (this.isScanLinkedExisting(scan)) {
            return 'warning';
        }
        return 'check';
    }

    getScanStatusColor(scan: ScanErgebnis): string {
        if (this.isScanImportFailed(scan)) {
            return '#9b0024';
        }
        if (this.isScanLinkedExisting(scan)) {
            return '#e65100';
        }
        return 'green';
    }

    getScanStatusTooltip(scan: ScanErgebnis): string {
        if (this.isScanImportFailed(scan)) {
            return this.getScanErrorTooltip(scan);
        }
        if (this.isScanLinkedExisting(scan)) {
            return 'Tier ist bereits in dieser Gruppe.';
        }
        return '';
    }

    isScanImportFailed(scan: ScanErgebnis): boolean {
        return (
            !!scan &&
            (scan.importFailed === true || !!scan.fehler || (scan.success === false && !scan.gt_id))
        );
    }

    isScanLinkedExisting(scan: ScanErgebnis): boolean {
        return !!scan?.gt_id && !!scan?.bereitsInGruppe && !this.isScanImportFailed(scan);
    }

    canEditGewichtForScan(scan: ScanErgebnis): boolean {
        return this.canEditGewicht && !!scan?.success && !!scan?.gt_id && !scan?.bereitsInGruppe;
    }

    clearLastScansHerkunftFilter(): void {
        if (!this.getActiveHerkunftFilter()) {
            return;
        }
        this.scansPageIndex = 0;
        this.setPassSourceMode('none');
    }

    getActiveHerkunftFilter(): EinstallHerkunftFilter | null {
        if (this.passSourceMode === 'none') {
            return null;
        }
        if (this.passSourceMode === 'haendler') {
            const viehhaendlerId = Number(this.haendlerCtrl.value?.viehhaendler_id || 0);
            return viehhaendlerId > 0 ? { viehhaendlerId } : null;
        }
        if (this.passSourceMode === 'kontakt') {
            const kontaktId = Number(this.selectedBetriebskontakte[0]?.kunde_id || 0);
            return kontaktId > 0 ? { betriebskontaktHaendlerId: kontaktId } : null;
        }
        return null;
    }

    private onEinstallTierlisteOrHerkunftChanged(): void {
        this.refreshTiereGesamtFromContext();
        this.refreshHerkunftTiereCount();
        this.reloadTierlisteScanList();
    }

    private ensureEinstallTierlisteForGruppe(): void {
        const gruppeId = this.gruppe?.gruppe_id ? this.gruppe.gruppe_id : Number(this.gruppeId);
        if (!gruppeId || gruppeId <= 0) {
            return;
        }

        const existingTierlisteId = this.einstallService.getCurrentEinstallTierlisteId();
        if (existingTierlisteId) {
            this.onEinstallTierlisteOrHerkunftChanged();
            return;
        }

        this.einstallTierlisteInitializing = true;
        this.ensureEinstallTierlisteSubscription?.unsubscribe();
        this.ensureEinstallTierlisteSubscription = this.einstallService
            .ensureEinstallTierliste(gruppeId, this.gruppe?.kunde_id, this.forceNewEinstallTierliste)
            .subscribe({
                next: () => {
                    this.einstallTierlisteInitializing = false;
                    this.onEinstallTierlisteOrHerkunftChanged();
                },
                error: err => {
                    this.einstallTierlisteInitializing = false;
                    this.messageService.errorMessage('Einstall-Tierliste konnte nicht erstellt werden!', err);
                },
            });
    }

    private isPassScan(ohrmarke: string): boolean {
        return ohrmarke.length === this.passScanLength;
    }

    private isOhrmarkeScan(ohrmarke: string): boolean {
        return ohrmarke.length === this.ohrmarkeScanLength;
    }

    get pagedScans(): ScanErgebnis[] {
        const start = this.scansPageIndex * this.scansPerPage;
        return this.gescannteOhrmarken.slice(start, start + this.scansPerPage);
    }

    get scansTotalPages(): number {
        return Math.max(1, Math.ceil(this.gescannteOhrmarken.length / this.scansPerPage));
    }

    get tiereGesamtDisplay(): string {
        const count = this.currentScanErgebnis?.anzahl_tiere_datensaetze;
        return count == null || Number.isNaN(Number(count)) ? '—' : String(count);
    }

    get aktAbteilDisplay(): string {
        const count = this.currentScanErgebnis?.anzahl_abteil;
        if (count) {
            return String(count);
        }
        const abteil = this.einstallService.resolveAbteil(this.abteilCtrl.value);
        if (abteil && this.gescannteOhrmarken.length > 0) {
            const matchCount = this.gescannteOhrmarken.filter(scan => scan.abteil?.trim() === abteil).length;
            if (matchCount > 0) {
                return String(matchCount);
            }
        }
        return '---';
    }

    get passGescanntDisplay(): string {
        return String(this.countPassGescannt(this.currentScanErgebnis));
    }

    get ohrmarkeGescanntDisplay(): string {
        return String(this.countOhrmarkeGescannt(this.currentScanErgebnis));
    }

    private countPassGescannt(source?: Pick<ScanErgebnis, 'paesse_ohne_tier' | 'anzahl_tiere_match'>): number {
        return (Number(source?.paesse_ohne_tier) || 0) + (Number(source?.anzahl_tiere_match) || 0);
    }

    private countOhrmarkeGescannt(source?: Pick<ScanErgebnis, 'tiere_ohne_pass' | 'anzahl_tiere_match'>): number {
        return (Number(source?.tiere_ohne_pass) || 0) + (Number(source?.anzahl_tiere_match) || 0);
    }

    getLastFiveDigits(ohrmarke: string | null | undefined): string {
        const normalized = String(ohrmarke || '').replace(/\s/g, '');
        if (!normalized) {
            return '';
        }
        return normalized.length > 5 ? normalized.substring(normalized.length - 5) : normalized;
    }

    loadGruppe() {
        this.isLoading = true;
        this.gruppeSubscription?.unsubscribe();
        this.gruppeSubscription = this.einstallService
            .loadGruppe(this.gruppe ? this.gruppe.gruppe_id : Number(this.gruppeId))
            .subscribe({
                next: (gruppe: Gruppe) => {
                    this.isLoading = false;
                    this.gruppe = gruppe;
                    this.applyGruppeScanStats();
                    this.einstallService.setCurrentGruppe(this.gruppe);
                    this.ensureEinstallTierlisteForGruppe();
                },
                error: err => {
                    this.isLoading = false;
                    this.messageService.errorMessage('Fehler!', err);
                },
            });
    }

    private applyGruppeScanStats(): void {
        if (!this.currentScanErgebnis) {
            this.currentScanErgebnis = new ScanErgebnis();
        }
        this.currentScanErgebnis.anzahl_tiere = this.gruppe?.anzahl_tiere_ohrmarken;
        this.currentScanErgebnis.anzahl_tiere_match = this.gruppe?.anzahl_tiere_match;
        this.currentScanErgebnis.paesse_ohne_tier = this.gruppe?.paesse_ohne_tier;
        this.currentScanErgebnis.tiere_ohne_pass = this.gruppe?.tiere_ohne_pass;
        this.einstallService.setScanErgebnisSubject(this.currentScanErgebnis);
    }

    private refreshTiereGesamtFromContext(): void {
        const gruppeId = this.gruppe?.gruppe_id ? this.gruppe.gruppe_id : Number(this.gruppeId);
        const tierlisteId = this.einstallService.getCurrentEinstallTierlisteId();
        if (!gruppeId || !tierlisteId) {
            if (this.gruppe && this.currentScanErgebnis) {
                this.currentScanErgebnis.anzahl_tiere_datensaetze = this.gruppe.anzahl_tiere_datensaetze;
                this.einstallService.setScanErgebnisSubject(this.currentScanErgebnis);
            }
            return;
        }
        this.einstallService.loadEinstallTierlisteAnzahl(gruppeId, tierlisteId, null).subscribe({
            next: anzahl => {
                if (!this.currentScanErgebnis) {
                    this.currentScanErgebnis = new ScanErgebnis();
                }
                this.currentScanErgebnis.anzahl_tiere_datensaetze = anzahl;
                this.einstallService.setScanErgebnisSubject(this.currentScanErgebnis);
            },
            error: () => {
                if (this.gruppe && this.currentScanErgebnis) {
                    this.currentScanErgebnis.anzahl_tiere_datensaetze = this.gruppe.anzahl_tiere_datensaetze;
                    this.einstallService.setScanErgebnisSubject(this.currentScanErgebnis);
                }
            },
        });
    }

    private refreshHerkunftTiereCount(): void {
        const filter = this.getActiveHerkunftFilter();
        if (!filter) {
            this.herkunftTiereCount = null;
            return;
        }

        const gruppeId = this.gruppe?.gruppe_id ? this.gruppe.gruppe_id : Number(this.gruppeId);
        const tierlisteId = this.einstallService.getCurrentEinstallTierlisteId();
        if (!gruppeId || !tierlisteId) {
            this.herkunftTiereCount = null;
            return;
        }

        this.herkunftTiereCountSubscription?.unsubscribe();
        this.herkunftTiereCountSubscription = this.einstallService
            .loadEinstallTierlisteAnzahl(gruppeId, tierlisteId, filter)
            .subscribe({
                next: anzahl => {
                    this.herkunftTiereCount = anzahl;
                },
                error: () => {
                    this.herkunftTiereCount = null;
                },
            });
    }

    private bumpHerkunftTiereCountOptimistically(): void {
        if (!this.getActiveHerkunftFilter()) {
            return;
        }
        const current = Number(this.herkunftTiereCount);
        this.herkunftTiereCount = Number.isFinite(current) ? current + 1 : 1;
    }

    private refreshCountsAfterTierAdded(): void {
        this.bumpHerkunftTiereCountOptimistically();
        this.refreshTiereGesamtFromContext();
        this.refreshHerkunftTiereCount();
    }

    compareHaendler(haendler1: Haendler, haendler2: Haendler) {
        return haendler1 && haendler2
            ? KieneUtils.sameId(haendler1.viehhaendler_id, haendler2.viehhaendler_id)
            : haendler1 === haendler2;
    }

    onScanEnter(event: Event): void {
        event.preventDefault();
        this.addOhrmarke();
    }

    addOhrmarke() {
        if (this.isScanInputDisabled) {
            return;
        }

        const ohrmarke = this.getScanInputValue();
        if (this.rejectInvalidScanInput(ohrmarke)) {
            return;
        }

        const startTime = performance.now();

        // this.ohrenmarkeCtrl.disable();

        this.ohrenmarkeCtrl.setValue('');
        this.ohrenmarkeInput?.focus();
        const abteil = this.einstallService.resolveAbteil(this.abteilCtrl.value);

        if (!this.einstallService.getCurrentEinstallTierlisteId()) {
            this.messageService.errorMessage('Einstall-Tierliste wird vorbereitet. Bitte kurz warten.', null);
            return;
        }

        if (this.isPassScan(ohrmarke)) {
            if (ohrmarke?.startsWith('276')) {
                if (!ohrmarke?.startsWith('27600')) {
                    this.messageService.errorMessage('Dies ist keine gültige Ohrmarke! (27600...)', null);
                    this.gruppenService.playScanSound(SoundType.ERROR);
                    return;
                }
            }
        }

        const gruppeTier: GruppeTier = new GruppeTier();

        gruppeTier.gruppe_id = this.gruppe?.gruppe_id ? this.gruppe?.gruppe_id : Number(this.gruppeId);
        if (this.gruppe?.kunde_id) {
            gruppeTier.kunde_id = this.gruppe.kunde_id;
        }
        gruppeTier.ohrmarke = ohrmarke;
        gruppeTier.abteil = abteil;
        gruppeTier.einstall_bemerkung = this.bemerkungCtrl?.value;
        if (this.datumCtrl.value) {
            gruppeTier.kp_einstalldatum = this.datumCtrl.value;
        }

        this.applyHerkunftToGruppeTier(gruppeTier);

        if (this.isOhrmarkeScan(ohrmarke)) {
            this.openTranspondernummer(gruppeTier, startTime);
        } else {
            this.postOhrmarkeOderPass(gruppeTier, startTime);
        }
    }

    setPassInputMode(mode: 'scan' | 'excel' | 'pdf'): void {
        this.passInputMode = mode;
        if (mode !== 'excel') {
            this.excelFormatHintVisible = false;
        }
        if (mode === 'scan') {
            setTimeout(() => this.ohrenmarkeInput?.focus(), 0);
        }
    }

    toggleExcelFormatHint(event?: Event): void {
        event?.stopPropagation();
        this.excelFormatHintVisible = !this.excelFormatHintVisible;
    }

    openPassExcelFileSelector(): void {
        if (!this.datumCtrl.value || this.excelUploadInProgress) {
            return;
        }
        this.passExcelFileInput?.nativeElement?.click();
    }

    onPassExcelFileSelected(event: Event): void {
        const input = event.target as HTMLInputElement;
        const file = input?.files?.item(0);
        this.selectedPassExcelFile = file || null;
        if (file) {
            this.uploadPassExcel(file);
        }
    }

    uploadPassExcel(file?: File): void {
        const excelFile = file || this.selectedPassExcelFile;
        if (!excelFile || !this.datumCtrl.value) {
            return;
        }

        this.excelUploadInProgress = true;
        const fd = new FormData();
        fd.append('gruppe_id', String(this.gruppe?.gruppe_id ? this.gruppe.gruppe_id : Number(this.gruppeId)));
        if (this.gruppe?.kunde_id) {
            fd.append('kunde_id', String(this.gruppe.kunde_id));
        }
        fd.append('dokument', excelFile);
        fd.append('kp_einstalldatum', new Date(this.datumCtrl.value).toISOString());
        fd.append('hit_meldung', '0');

        if (this.selectedBetriebskontakte.length > 0) {
            fd.append('betriebskontakt_haendler_id', String(this.selectedBetriebskontakte[0].kunde_id));
        } else if (this.haendlerCtrl.value?.viehhaendler_id) {
            fd.append('viehhaendler_id', String(this.haendlerCtrl.value.viehhaendler_id));
        }

        if (this.bemerkungCtrl?.value) {
            fd.append('bemerkung', this.bemerkungCtrl.value);
        }

        const abteil = this.einstallService.resolveAbteil(this.abteilCtrl.value);
        if (abteil) {
            fd.append('abteil', abteil);
        }

        const einstallTierlisteId = this.einstallService.getCurrentEinstallTierlisteId();
        if (einstallTierlisteId && einstallTierlisteId > 0) {
            fd.append('einstall_tierliste_id', String(einstallTierlisteId));
        }

        const headers = new HttpHeaders('Phito-Type: fileupload');
        this.http.post<any>(`${this.apiBaseUrl}gruppe_tier/create_kundenportal_excel.php`, fd, { headers }).subscribe({
            next: resp => {
                const importedScans = this.mapImportedScans(resp?.inserted_scans);
                const linkedGtIds = Array.isArray(resp?.linked_gt_ids)
                    ? resp.linked_gt_ids.map((id: unknown) => Number(id)).filter((id: number) => id > 0)
                    : [];
                this.einstallService.registerBereitsInGruppeGtIds(linkedGtIds);
                const failedScans = importedScans.filter(scan => scan.importFailed === true);
                const successOhrmarken = importedScans
                    .filter(scan => scan.success !== false)
                    .map(scan => scan.ohrmarke_notnull);
                this.einstallService.removeFailedImportScansForOhrmarken(successOhrmarken);
                this.einstallService.registerFailedImportScans(failedScans);
                const successCount = Number(resp?.success_count ?? importedScans.filter(scan => scan.success).length);
                const failedCount = Number(resp?.failed_count ?? failedScans.length);
                const requestedCount = Number(resp?.requested_count ?? 0);

                if (successCount > 0) {
                    let message = `Excel-Datei erfolgreich hochgeladen. ${successCount}`;
                    if (requestedCount > 0) {
                        message += ` von ${requestedCount}`;
                    }
                    message += ' Tieren wurden verarbeitet.';
                    if (failedCount > 0) {
                        message += ` ${failedCount} Tier(e) konnten nicht importiert werden.`;
                    }
                    this.messageService.infoMessage(message);
                } else if (failedCount > 0) {
                    this.messageService.errorMessage(
                        failedCount === requestedCount
                            ? 'Keine Tiere importiert. Alle Zeilen der Excel-Datei sind fehlgeschlagen.'
                            : 'Keine Tiere importiert.',
                        null,
                    );
                } else {
                    this.messageService.errorMessage('Keine Tiere in der Excel-Datei gefunden.', null);
                }
                this.selectedPassExcelFile = null;
                if (this.passExcelFileInput?.nativeElement) {
                    this.passExcelFileInput.nativeElement.value = '';
                }
                this.loadGruppe();
                this.onEinstallTierlisteOrHerkunftChanged();
                this.einstallService.ladeEingestallteTiere();
                this.excelUploadInProgress = false;
            },
            error: err => {
                this.messageService.errorMessage('Fehler beim Hochladen der Excel-Datei!', err);
                this.excelUploadInProgress = false;
            },
        });
    }

    private buildPdfImportPrefill(): GruppeTierScanImportierenDialogPrefill | undefined {
        const prefill: GruppeTierScanImportierenDialogPrefill = {};
        let hasValue = false;

        if (this.datumCtrl.value) {
            prefill.kpEinstalldatum = this.datumCtrl.value;
            hasValue = true;
        }
        const bemerkung = this.bemerkungCtrl.value?.trim();
        if (bemerkung) {
            prefill.bemerkung = bemerkung;
            hasValue = true;
        }
        const abteil = this.einstallService.resolveAbteil(this.abteilCtrl.value);
        if (abteil) {
            prefill.abteil = abteil;
            hasValue = true;
        }
        if (this.passSourceMode === 'kontakt' && this.selectedBetriebskontakte[0]) {
            prefill.betriebskontakt = this.selectedBetriebskontakte[0];
            hasValue = true;
        } else if (this.passSourceMode === 'haendler' && this.haendlerCtrl.value?.viehhaendler_id) {
            prefill.viehhaendler = this.haendlerCtrl.value;
            hasValue = true;
        }

        return hasValue ? prefill : undefined;
    }

    openPassPdfImportDialog(): void {
        this.dialog
            .open(GruppeTierScanImportierenDialogComponent, {
                data: {
                    gruppe: this.gruppe,
                    prefill: this.buildPdfImportPrefill(),
                    einstall_tierliste_id: this.einstallService.getCurrentEinstallTierlisteId(),
                },
            })
            .afterClosed()
            .subscribe((uploaded: boolean) => {
                if (uploaded) {
                    this.messageService.infoMessage('PDF-Import gestartet. Die Verarbeitung laeuft im Hintergrund.');
                    this.passPdfVerwaltung?.refresh();
                    this.loadGruppe();
                }
            });
    }

    onPassPdfTiereUpdated(): void {
        this.loadGruppe();
        this.onEinstallTierlisteOrHerkunftChanged();
        this.reloadTierlisteScanList();
    }

    openTranspondernummer(gruppeTier: GruppeTier, startTime: number) {
        if (this.mitTransponderNummerToggleCtrl.value) {
            this.dialog
                .open(TransponderNummerEingebenDialogComponent)
                .afterClosed()
                .subscribe(transponderNummer => {
                    if (transponderNummer) {
                        gruppeTier.transpondernummer = transponderNummer;
                    }
                    this.postOhrmarkeOderPass(gruppeTier, null);
                });
        } else {
            this.postOhrmarkeOderPass(gruppeTier, startTime);
        }
    }

    openHaendlerVerwaltung() {
        if (!this.canEditHaendler) {
            return;
        }
        const dialogRef = this.dialog.open(HaendlerDetailsDialogComponent, { minWidth: '90vw' });
        dialogRef.afterClosed().subscribe({
            next: result => {
                if (result) {
                    this.ladeHaendlerFavoriten();
                    this.haendlerCtrl.setValue(result, { emitEvent: true });
                }
            },
        });
    }

    scanLoeschen(ergebnis: ScanErgebnis) {
        if (ergebnis.success) {
            const input = new ConfirmDialogInput();
            input.headline = 'Tier löschen';
            input.text = 'Soll das Tier "' + ergebnis.ohrmarke_notnull + '" wirklich gelöscht werden?';
            input.okButton = 'Löschen';

            const dialogRef = this.dialog.open(ConfirmDialogComponent, { data: input });

            dialogRef.afterClosed().subscribe({
                next: (accepted: ConfirmDialogResult) => {
                    if (accepted?.confirmed) {
                        this.gruppenService.scanLoeschen(ergebnis).subscribe({
                            next: () => {
                                this.messageService.infoMessage('Das Tier wurde gelöscht');

                                this.einstallService.removeScanErgebnis(ergebnis.gt_id);
                                this.gescannteOhrmarken = this.einstallService.getLastScanErgebnisse();
                                this.ensureScansPageInRange();

                                // lade Anzahl der Tiere neu
                                this.loadGruppe();
                                this.onEinstallTierlisteOrHerkunftChanged();
                                // aktualisiere Anzahl fuer aktuelles Abteil
                                if (this.abteilCtrl.value && this.currentScanErgebnis) {
                                    this.currentScanErgebnis.anzahl_abteil -= 1;
                                }
                                if (this.haendlerCtrl.value && this.currentScanErgebnis) {
                                    this.currentScanErgebnis.anzahl_viehhaendler -= 1;
                                }
                                this.ohrenmarkeInput?.focus();
                            },
                            error: err => {
                                this.messageService.errorMessage('Tier konnte nicht gelöscht werden!', err);
                            },
                        });
                    }
                },
                error: err => {
                    this.messageService.errorMessage('Fehler!', err);
                },
            });
        }
    }

    canReklamierenScan(scan: ScanErgebnis): boolean {
        return !!scan?.success && Number(scan?.gt_id) > 0;
    }

    reklamationFuerScanHinzufuegen(scanResult: ScanErgebnis) {
        if (!this.canReklamierenScan(scanResult)) {
            return;
        }

        const gruppeId = Number(this.gruppeId || 0);
        if (gruppeId > 0) {
            this.router
                .navigate(['/gruppen/tierehinzufuegen', gruppeId, 'tierreklamation', scanResult.gt_id])
                .then();
            return;
        }

        const tier = new GruppeTier();
        tier.gt_id = scanResult.gt_id;
        tier.ohrmarke_notnull = scanResult.ohrmarke_notnull;

        this.dialog
            .open(GruppeTierReklamierenDialogComponent, {
                width: '760px',
                maxWidth: '95vw',
                maxHeight: '85vh',
                autoFocus: false,
                data: { tier: tier },
            })
            .afterClosed()
            .subscribe({
                next: () => {
                    // this.einstallService.ladeEingestallteTiere();
                },
            });
    }

    gewichtFuerScanBearbeiten(scanResult: ScanErgebnis) {
        if (!this.canEditGewichtForScan(scanResult)) {
            return;
        }
        this.dialog
            .open(GewichtEingebenNumberpadDialogComponent, {
                data: { gewicht: scanResult?.einstallgewicht },
            })
            .afterClosed()
            .subscribe(gewicht => {
                if (!gewicht || Number.isNaN(gewicht)) {
                    return;
                }
                this.saveEinstallgewichtForScan(scanResult, gewicht);
            });
    }

    hasAbteilungsChange(currentOhrmarke: ScanErgebnis, i: number) {
        if (this.gescannteOhrmarken?.length > 1) {
            const previousOhrmarke = this.gescannteOhrmarken[i - 1];
            return currentOhrmarke.abteil !== previousOhrmarke.abteil;
        } else {
            return false;
        }
    }

    changeTransponderNrToggle(event: MouseEvent) {
        event.preventDefault();
        event.stopPropagation();
        if (this.isLoading) {
            return;
        }
        this.mitTransponderNummerToggleCtrl.setValue(!this.mitTransponderNummerToggleCtrl.value);
    }

    private postOhrmarkeOderPass(gt: GruppeTier, startTime: number) {
        const einstallTierlisteId = this.einstallService.getCurrentEinstallTierlisteId();
        if (einstallTierlisteId) {
            (gt as GruppeTier & { einstall_tierliste_id?: number }).einstall_tierliste_id = einstallTierlisteId;
        }
        this.appService.setBlockOnLoading(true);
        this.api.post(this.apiBaseUrl + 'gruppe_tier/create_kundenportal.php', gt, undefined).subscribe({
            next: (result: ScanErgebnis) => {
                this.handleScanApiSuccess(result, startTime, gt.ohrmarke);
            },
            error: err => {
                // this.ohrenmarkeCtrl.enable();
                this.gruppenService.playScanSound(SoundType.ERROR);
                this.messageService.errorMessage('Fehler!', err);
                const scanResult = new ScanErgebnis();
                scanResult.ohrmarke_notnull = gt?.ohrmarke;
                scanResult.success = false;
                scanResult.importFailed = true;
                scanResult.fehler = this.extractApiErrorText(err);
                this.einstallService.registerFailedImportScans([scanResult]);
                this.einstallService.addScanErgebnis(scanResult);
                this.syncScansFromService();
                this.openCloseState = 'openError';
                this.timeMs = null;
                setTimeout(() => {
                    this.openCloseState = 'closedError';
                }, 400);
                this.appService.setBlockOnLoading(false);
            },
        });
    }

    private handleScanApiSuccess(result: ScanErgebnis, startTime: number | null, scannedInput?: string): void {
        const scanResult = result;
        scanResult.success = true;
        const scannedValue = String(scannedInput || '').trim();
        const apiBereitsInGruppe = !!result.bereits_in_gruppe || !!result.bereitsInGruppe;
        const isComplement = scannedValue && isComplementScanSuccess(scanResult, scannedValue);
        scanResult.bereitsInGruppe = apiBereitsInGruppe && !isComplement;

        if (scanResult.bereitsInGruppe && scanResult.gt_id) {
            this.einstallService.registerBereitsInGruppeGtIds([scanResult.gt_id]);
        }

        this.currentScanErgebnis = result;

        if (scanResult.bereitsInGruppe) {
            this.messageService.hintMessage(this.buildBereitsInGruppePopupText(scanResult));
            this.gruppenService.playScanSound(SoundType.WARNING);
            this.openCloseState = 'closed';
            this.openCloseState = 'open';
            this.einstallService.setScanErgebnisSubject(this.currentScanErgebnis);
            this.einstallService.addScanErgebnis(scanResult);
            this.syncScansFromService();
            this.scansPageIndex = 0;
            this.refreshTiereGesamtFromContext();
            this.refreshHerkunftTiereCount();
            setTimeout(() => {
                this.openCloseState = 'closed';
            }, 400);
            this.timeMs = startTime ? Math.round(performance.now() - startTime) : null;
            this.appService.setBlockOnLoading(false);
            return;
        }

        if (scannedValue && isDuplicateScanType(scanResult, scannedValue)) {
            this.gruppenService.playScanSound(SoundType.WARNING);
            this.openCloseState = 'closeDuplicate';
            this.openCloseState = 'openDuplicate';
            setTimeout(() => {
                this.openCloseState = 'closeDuplicate';
            }, 400);
            this.appService.setBlockOnLoading(false);
            return;
        }

        this.gruppenService.playScanSound(SoundType.OK);
        this.openCloseState = 'closed';
        this.openCloseState = 'open';

        this.einstallService.setScanErgebnisSubject(this.currentScanErgebnis);
        this.einstallService.addScanErgebnis(scanResult);
        this.syncScansFromService();
        this.refreshCountsAfterTierAdded();

        if (result.betriebskontakt_haendler_id) {
            this.loadBetriebskontaktHaendlerForScanResult(result);
        }

        setTimeout(() => {
            this.openCloseState = 'closed';
        }, 400);

        this.timeMs = startTime ? Math.round(performance.now() - startTime) : null;
        this.appService.setBlockOnLoading(false);
    }

    private saveEinstallgewichtForScan(scanResult: ScanErgebnis, gewicht: number): void {
        this.einstallService.setPendingGewicht(scanResult.gt_id, gewicht);
        for (const scan of this.gescannteOhrmarken) {
            if (scan.gt_id === scanResult.gt_id) {
                scan.einstallgewicht = gewicht;
                break;
            }
        }

        const gsId = Number(this.gruppe?.gs_id || this.einstallService.getCurrentGruppe()?.gs_id || 0);
        if (gsId <= 0) {
            this.messageService.infoMessage('Gewicht vorgemerkt. Speicherung erfolgt beim Melden.');
            return;
        }

        this.einstallService
            .persistEinstallgewichte([{ gt_id: scanResult.gt_id, gewicht }], gsId)
            .subscribe({
                next: () => this.messageService.infoMessage('Gewicht gespeichert.'),
                error: err =>
                    this.messageService.errorMessage('Gewicht konnte nicht gespeichert werden!', err),
            });
    }

    onBetriebskontaktEntfernen(): void {
        this.selectedBetriebskontakte = [];
        if (!this.haendlerCtrl.value?.viehhaendler_id) {
            this.passSourceMode = 'none';
        }
        this.syncHerkunftToService();
        this.onEinstallTierlisteOrHerkunftChanged();
    }

    // Neue Methoden für den Betriebskontakt-Auswahl-Dialog
    onBetriebskontaktSelected(kontakt: any): void {
        if (kontakt) {
            // Aktualisiere die lokale Auswahl
            this.selectedBetriebskontakte = [kontakt];
            this.passSourceMode = 'kontakt';

            // Wenn ein Kontakt ausgewählt wird, Händler-Auswahl zurücksetzen
            this.haendlerCtrl.setValue(null, { emitEvent: false });
            this.syncHerkunftToService();
            this.onEinstallTierlisteOrHerkunftChanged();
        }
    }

    onBetriebskontakteSelected(kontakte: any[]): void {
        if (kontakte && kontakte.length > 0) {
            this.onBetriebskontaktSelected(kontakte[0]);
        }
    }

    private convertBetriebskontaktToHaendler(kontakt: any): Haendler {
        const haendler = new Haendler();
        haendler.viehhaendler_id = kontakt.kunde_id || 0; // Verwende kunde_id statt kontakt_id
        haendler.name = kontakt.bezeichnung_final || '';
        haendler.vvvo = kontakt.vvvo || '';
        haendler.strasse = kontakt.strasse_final || '';
        haendler.plz = kontakt.plz_final ? parseInt(kontakt.plz_final, 10) || 0 : 0;
        haendler.ort = kontakt.ort_final || '';
        haendler.telefon = kontakt.telefon_1 || '';
        haendler.mobil = kontakt.mobil_1 || '';
        haendler.email = kontakt.email || '';
        haendler.favorit = kontakt.favorit || 0;
        return haendler;
    }

    setPassSourceMode(mode: 'none' | 'haendler' | 'kontakt'): void {
        this.passSourceMode = mode;

        if (mode !== 'haendler') {
            this.haendlerCtrl.setValue(null, { emitEvent: false });
        }

        if (mode !== 'kontakt') {
            this.selectedBetriebskontakte = [];
        }

        this.syncHerkunftToService();
        this.onEinstallTierlisteOrHerkunftChanged();
    }

    private applyHerkunftToGruppeTier(gruppeTier: GruppeTier): void {
        const kontaktId = Number(this.selectedBetriebskontakte[0]?.kunde_id || 0);
        const serviceKontaktId = Number(this.einstallService.getCurrentBetriebskontaktHaendlerId() || 0);
        const resolvedKontaktId = kontaktId > 0 ? kontaktId : serviceKontaktId;

        if (resolvedKontaktId > 0) {
            gruppeTier.betriebskontakt_haendler_id = resolvedKontaktId;
            gruppeTier.viehhaendler_id = null;
            return;
        }

        const haendlerId = Number(this.haendlerCtrl.value?.viehhaendler_id || 0);
        const serviceHaendlerId = Number(this.einstallService.getCurrentHaendler()?.viehhaendler_id || 0);
        const resolvedHaendlerId = haendlerId > 0 ? haendlerId : serviceHaendlerId;

        if (resolvedHaendlerId > 0) {
            gruppeTier.viehhaendler_id = resolvedHaendlerId;
            gruppeTier.betriebskontakt_haendler_id = null;
        }
    }

    private syncHerkunftToService(): void {
        if (this.passSourceMode === 'kontakt' && this.selectedBetriebskontakte[0]?.kunde_id) {
            this.einstallService.setCurrentBetriebskontaktHaendlerId(this.selectedBetriebskontakte[0].kunde_id);
            this.einstallService.setCurrentHaendler(null);
            return;
        }
        if (this.passSourceMode === 'haendler' && this.haendlerCtrl.value?.viehhaendler_id) {
            this.einstallService.setCurrentHaendler(this.haendlerCtrl.value);
            this.einstallService.setCurrentBetriebskontaktHaendlerId(null);
            return;
        }
        this.einstallService.clearCurrentHerkunft();
    }

    private reloadTierlisteScanList(): void {
        const gruppeId = this.gruppe?.gruppe_id ? this.gruppe.gruppe_id : Number(this.gruppeId);
        const tierlisteId = this.einstallService.getCurrentEinstallTierlisteId();
        if (!gruppeId || !tierlisteId) {
            this.syncScansFromService();
            return;
        }

        this.tierlisteTiereSubscription?.unsubscribe();
        this.tierlisteTiereSubscription = this.einstallService
            .loadEinstallTierlisteTiere(gruppeId, tierlisteId, this.getActiveHerkunftFilter())
            .subscribe({
                next: scans => {
                    this.einstallService.setLastScanErgebnisse(scans || []);
                    this.syncScansFromService();
                },
                error: () => {
                    this.einstallService.setLastScanErgebnisse([]);
                    this.syncScansFromService();
                },
            });
    }

    private loadBetriebskontaktHaendlerForScanResult(scanResult: ScanErgebnis): void {
        if (scanResult.betriebskontakt_haendler_id) {
            this.betriebskontakteService.getBetriebskontaktById(scanResult.betriebskontakt_haendler_id).subscribe({
                next: (kontakt: Betriebskontakt) => {
                    scanResult.betriebskontaktHaendler = kontakt;
                    const name = (kontakt?.bezeichnung_final || kontakt?.bezeichnung || '').trim();
                    if (name) {
                        scanResult.betriebskontakt_haendler_name = name;
                    }
                },
                error: err => {},
            });
        } else {
        }
    }

    private currentUserCanEditGewicht(): boolean {
        return this.localStorageService.hasPermission(this.gewichtPermissionId);
    }

    previousScansPage(): void {
        if (this.scansPageIndex <= 0) {
            return;
        }
        this.scansPageIndex -= 1;
    }

    nextScansPage(): void {
        if (this.scansPageIndex >= this.scansTotalPages - 1) {
            return;
        }
        this.scansPageIndex += 1;
    }

    private mapImportedScans(scans: any[]): ScanErgebnis[] {
        if (!Array.isArray(scans)) {
            return [];
        }
        return scans
            .filter(scan => scan && scan.ohrmarke_notnull)
            .map(scan => {
                const result = new ScanErgebnis();
                if (scan.gt_id) {
                    result.gt_id = Number(scan.gt_id);
                }
                result.ohrmarke_notnull = String(scan.ohrmarke_notnull);
                result.success =
                    scan.success === false || scan.success === 0 || scan.success === 'false' ? false : scan.success !== false;
                result.bereitsInGruppe = !!scan.bereits_in_gruppe || !!scan.bereitsInGruppe;
                result.importFailed =
                    scan.import_failed === true ||
                    scan.importFailed === true ||
                    (result.success === false && !result.gt_id);
                if (scan.fehler) {
                    result.fehler = String(scan.fehler);
                }
                return result;
            });
    }

    private buildBereitsInGruppePopupText(scan: ScanErgebnis): string {
        const ohrmarke = String(scan?.ohrmarke_notnull || '').trim();
        if (ohrmarke) {
            return `Tier ${ohrmarke} ist bereits in dieser Gruppe.`;
        }
        return 'Tier ist bereits in dieser Gruppe.';
    }

    private extractApiErrorText(errorObject: any): string {
        if (!errorObject) {
            return 'Tier konnte nicht importiert werden.';
        }
        if (errorObject.status === 0) {
            return 'Keine Internetverbindung!';
        }
        const payload = errorObject.error;
        if (!payload) {
            return 'Tier konnte nicht importiert werden.';
        }
        if (typeof payload === 'string') {
            try {
                const parsed = JSON.parse(payload);
                return String(parsed?.errortext || parsed?.fehler || payload).trim();
            } catch {
                return payload.trim();
            }
        }
        if (payload.errortext) {
            return String(payload.errortext).trim();
        }
        if (payload.fehler) {
            return String(payload.fehler).trim();
        }
        return 'Tier konnte nicht importiert werden.';
    }

    private prependImportedScans(importedScans: ScanErgebnis[]): void {
        if (!importedScans || importedScans.length === 0) {
            return;
        }
        const existingGtIds = new Set(this.einstallService.getLastScanErgebnisse().map(scan => scan?.gt_id).filter(id => !!id));
        for (let i = importedScans.length - 1; i >= 0; i -= 1) {
            const scan = importedScans[i];
            if (scan.gt_id && existingGtIds.has(scan.gt_id)) {
                continue;
            }
            this.einstallService.addScanErgebnis(scan);
            if (scan.gt_id) {
                existingGtIds.add(scan.gt_id);
            }
        }
        this.syncScansFromService();
        this.scansPageIndex = 0;
    }

    private syncScansFromService(): void {
        this.gescannteOhrmarken = this.einstallService.getLastScanErgebnisse();
        this.ensureScansPageInRange();
    }

    private ensureScansPageInRange(): void {
        const maxIndex = Math.max(0, this.scansTotalPages - 1);
        if (this.scansPageIndex > maxIndex) {
            this.scansPageIndex = maxIndex;
        }
    }
}
